const widdowJoiner = (str: string) => {
  const lastSpace = str.lastIndexOf(" ");
  const joinLastTwo = str.substring(0, lastSpace) + "\u00a0" + str.substring(lastSpace + 1);
  return joinLastTwo;
};

export { widdowJoiner };
